export const PATH = {
  landing: '/',
  developer: '/developer',
  emptyDeliveryTypes: '/empty-delivery-types',
  oauthCallback: '/auth/oauth/callback',
  magicLinkVerify: '/magic-link/verify',
  profileEmailVerify: '/profile/email/verify',

  basket: '/basket',
  catalog: '/catalog',
  profile: '/profile',
  settings: '/settings',
  documents: '/documents',
  documentView: '/document-view',
  ordersHistory: '/orders-history',
  aboutPage: '/about-page',

  order: '/order/:id',
  orderBuild: (id: string) => `/order/${id}`,
  product: '/product/:id',
  productBuild: (id: string) => `/product/${id}`,
  successPath: '/success',
  success: '/success/:id',
  successBuild: (id: string) => `/success/${id}`,
};
